

























































































































import Vue from 'vue'
import Component from 'vue-class-component'
import moment from 'moment'
import { RezitoreAdminAPI } from '@/provider/api'
import CircularLoading from '@/components/Loading/CircularLoading.vue'
import Snackbar from '@/components/Common/Snackbar.vue'
import Dialog from '@/components/Common/Dialog.vue'
import CrcMasterProvider, { CrcMasterModel } from '@/provider/crcMaster'
import ManageCognitoUserProvider from '@/provider/cognitoUser'
import AwsExports from '@/assets/aws-exports'
import { UserInfoProvider, ManagerUserInfoProvider } from '../provider/userInfo'
import { AuthDynamoDB } from '../provider/dynamodb'
import { Setting } from '@/setting'
import {
  CONSENT_WITHDRAWAL_STATUS_DECLINED,
  CONSENT_WITHDRAWAL_STATUS_RETRACTED,
  CONSENT_WITHDRAWAL_STATUS_DATA_REMOVED
} from '@/constants'

@Component({
  components: {
    CircularLoading,
    Snackbar,
    Dialog
  }
})
export default class UserHome extends Vue {
  api: RezitoreAdminAPI = new RezitoreAdminAPI()
  loading: boolean = false
  userId: string = ''
  userName: string = ''
  data: any = {}
  tableUserData: Array<DataTableItem> = []

  surveys: Array<{
      title: string,
      items: Array<DataTableItem>
    }> = []

  defaultCrcId: string = ''
  get hasCrcChanges () {
    return this.data.crcId ? (this.defaultCrcId !== this.data.crcId) : false
  }

  get enableUpdateCrc () {
    return Setting.ENABLE_UPDATE_CRC
  }

  crcItems: CrcMasterModel[] = []
  crcMasterProvider: CrcMasterProvider = new CrcMasterProvider()

  get rewordDisplayName () {
    if (this.data.rewardStatus === 'unprocessed') {
      return '未謝礼'
    }
    if (this.data.rewardStatus === 'processed') {
      return '謝礼済'
    }
    return '対象外'
  }

  get rewordClass () {
    if (this.data.rewardStatus === 'unprocessed') {
      return 'unprocessed'
    }
    if (this.data.rewardStatus === 'processed') {
      return 'processed'
    }
    return ''
  }

  get canReward () {
    if (this.data.rewardStatus === 'unprocessed' || this.data.rewardStatus === 'processed') {
      return true
    }
    return false
  }

  get isRewardChecked () {
    if (!this.data.rewardStatus || this.data.rewardStatus !== 'processed') {
      return false
    }
    return true
  }

  get rewardDate () {
    const date = this.data.rewardRecord
    return date ? moment(date).format('YYYY MM/DD') : ''
  }

  get consentWithdrawalDisplayName (): string {
    const status = this.data.consentWithdrawalStatus
    if (status === CONSENT_WITHDRAWAL_STATUS_DECLINED) {
      return '参加拒否'
    } else if (status === CONSENT_WITHDRAWAL_STATUS_RETRACTED) {
      return '同意撤回'
    } else if (status === CONSENT_WITHDRAWAL_STATUS_DATA_REMOVED) {
      return 'データ削除'
    }
    return '通常参加'
  }

  get consentWithdrawalDate (): string {
    const date = this.data.consentWithdrawalRecord
    return date ? moment(date).format('YYYY MM/DD') : ''
  }

  get consentWithdrawals (): Array<{ name: string, value: string}> {
    const status = this.data.consentWithdrawalStatus
    if (status === CONSENT_WITHDRAWAL_STATUS_DATA_REMOVED) {
      return []
    } else if (status === CONSENT_WITHDRAWAL_STATUS_RETRACTED) {
      return [
        { name: 'データ削除', value: CONSENT_WITHDRAWAL_STATUS_DATA_REMOVED }
      ]
    } else if (status === CONSENT_WITHDRAWAL_STATUS_DECLINED) {
      return [
        { name: '同意撤回', value: CONSENT_WITHDRAWAL_STATUS_RETRACTED },
        { name: 'データ削除', value: CONSENT_WITHDRAWAL_STATUS_DATA_REMOVED }
      ]
    }
    return [
      { name: '参加拒否', value: CONSENT_WITHDRAWAL_STATUS_DECLINED },
      { name: '同意撤回', value: CONSENT_WITHDRAWAL_STATUS_RETRACTED },
      { name: 'データ削除', value: CONSENT_WITHDRAWAL_STATUS_DATA_REMOVED }
    ]
  }

  get canChangeConsentWithdrawal (): boolean {
    return this.data.consentWithdrawalStatus !== CONSENT_WITHDRAWAL_STATUS_DATA_REMOVED
  }

  cognitoProvider: ManageCognitoUserProvider = new ManageCognitoUserProvider(
    AwsExports.userRegistrationTargetUserPoolID
  )

  provider: UserInfoProvider = new ManagerUserInfoProvider(
    new AuthDynamoDB(),
    AwsExports.userInfoTable,
    this.$store.getters.currentDivision.id
  )

  $refs!: {
    crcSelect: any
    snackbar: Snackbar
    dialog: Dialog
  }

  mounted () {
    this.crcMasterProvider
      .load()
      .then((crcItems: CrcMasterModel[]) => {
        this.crcItems = crcItems
      })
      .catch((error: any) => {
        throw new Error(error)
      })
  }

  beforeMount () {
    this.userId = this.$route.params.userId
    this.userName = this.$route.params.username
    this.loadUserData()
  }

  getCrcName (id: string) {
    const crc = this.crcItems.find(crc => crc.id === id)
    return crc ? crc.name : ''
  }

  async updateCrc () {
    const newCrcId = this.data.crcId
    // console.log('newCrcId:', this.data.crcId)
    if (newCrcId === '') {
      this.showSnackbar('所属を選択してください')
      return
    }
    try {
      this.loading = true

      // Cognito側の担当者設定変更
      await this.cognitoProvider.changeCrcId(this.userName, newCrcId)

      // UserInfoテーブル側の担当者設定変更
      const key = { division: this.data.division, sortDate: this.data.sortDate }
      await this.provider.updateValue(key, 'crcId', newCrcId)

      // Cognito側とUserInfoテーブル側の担当者設定が両方とも成功したら、初期値を同期して更新ボタンを不活性化する。
      // 片方がエラーで失敗しても再度更新ボタン押せば良いし、エラーのまま放置してもUserInfoテーブルはユーザー一覧の更新でCognitoの情報と同期されるので、特に問題はない。
      this.defaultCrcId = newCrcId
    } catch (error) {
      console.error(error)
      this.showSnackbar('所属の設定に失敗しました。再度実行して下さい。')
    } finally {
      this.loading = false
    }
  }

  onRewardRecordStatusChange (event: any, dataTableItem: DataTableItem) {
    console.log('onRewardRecordStatusChange - event:', event)
    if (!event) {
      return
    }

    const checked = event.target.checked
    const rewardRecordStatusChange = async (yes: boolean) => {
      console.log('rewardRecordStatusChange - yes:', yes)
      if (yes) {
        try {
          const key = {
            division: this.data.division,
            sortDate: this.data.sortDate
          }
          const rewardStatus = checked ? 'processed' : 'unprocessed'
          const rewardRecord = checked ? new Date().toISOString() : null
          const attribute1 = { name: 'rewardStatus', value: rewardStatus }
          const attribute2 = { name: 'rewardRecord', value: rewardRecord }
          await this.provider.updateValues(key, attribute1, attribute2)
          this.data = { ...this.data, rewardStatus, rewardRecord }
          dataTableItem.value = this.rewordDisplayName
          dataTableItem.valueClass = this.rewordClass
        } catch (e) {
          this.showSnackbar('謝礼記録の更新に失敗しました')
          event.target.checked = !checked
        }
      } else {
        event.target.checked = !checked
      }
    }

    this.showDialog(
      '謝礼記録',
      (checked ? '謝礼済' : '未謝礼') + 'に変更しますか？',
      rewardRecordStatusChange
    )
  }

  onConsentWithdrawalStatusChange (
    item: { name: string, value: string},
    dataTableItem: DataTableItem
  ) {
    console.log('onConsentWithdrawalStatusChange - item:', item)
    if (!item) {
      return
    }

    const consentWithdrawalStatusChange = async (yes: boolean) => {
      console.log('consentWithdrawalStatusChange - yes:', yes)
      if (yes) {
        try {
          const status = item.value
          const response = await this.api.setConsentWithdrawal(this.userId, status)
          console.log('api.setConsentWithdrawal', response)
          const result = JSON.parse(response)
          const consentWithdrawalStatus = result.item.consentWithdrawalStatus
          const consentWithdrawalRecord = result.item.consentWithdrawalRecord
          this.data = { ...this.data, consentWithdrawalStatus, consentWithdrawalRecord }
          if (status === CONSENT_WITHDRAWAL_STATUS_DATA_REMOVED) {
            this.data.nickname = ''
            this.data.age = undefined
            this.data.sex = undefined
            this.data.phoneNumber = undefined
            this.data.appVersion = ''
            this.data.crcId = undefined
            this.data.preSurvey = undefined
            this.setupData()
          } else {
            dataTableItem.value = this.consentWithdrawalDisplayName
          }
        } catch (e) {
          this.showSnackbar('同意状態変更の変更に失敗しました')
        }
      }
    }

    this.showDialog(
      '同意状態変更',
      `「${item.name}」に変更しますか？`,
      consentWithdrawalStatusChange
    )
  }

  showSnackbar (message: string) {
    this.$refs.snackbar.showSnackbar(message)
  }

  showDialog (title: string, message: string, callback:(value:boolean)=>void) {
    this.$refs.dialog.showDialog(title, message, callback)
  }

  async loadUserData () {
    this.loading = true
    const data = await this.api.getUserBasicInfo(this.userId)
    this.data = JSON.parse(data)
    this.setupData()
    this.loading = false
  }

  private setupData () {
    const tableUserData: Array<DataTableItem> = [
      { key: 'username', value: this.data.username },
      { key: 'ニックネーム', value: this.data.nickname }
    ]
    if (this.data.age) {
      tableUserData.push({ key: '年齢', value: this.data.age })
    }
    if (this.data.sex) {
      const sex: any = { male: '男性', female: '女性' }
      tableUserData.push({ key: '性別', value: sex[this.data.sex] })
    }
    if (this.data.email) {
      tableUserData.push({ key: 'email', value: this.data.email })
    }
    if (this.data.phoneNumber) {
      tableUserData.push({ key: '電話番号', value: this.data.phoneNumber })
    }
    const date = this.data.assignedAt
    const assignedAt = date ? moment(date).format('YYYY MM/DD HH:mm:ss') : ''
    this.tableUserData = tableUserData.concat([
      { key: 'デバイス', value: this.data.os },
      { key: 'アプリバージョン', value: this.data.appVersion },
      { key: '割付日', value: assignedAt },
      { key: '割付番号', value: this.data.assignment },
      {
        key: 'crcId',
        value: this.data.crcId,
        type: 'crc'
      },
      {
        key: '謝礼',
        value: this.rewordDisplayName,
        valueClass: this.rewordClass,
        type: 'reward'
      },
      {
        key: '同意状態',
        value: this.consentWithdrawalDisplayName,
        type: 'consentWithdrawal'
      }
    ])

    this.defaultCrcId = this.data.crcId

    if (this.data.preSurvey !== undefined) {
      const surveyKeys = Object.keys(this.data.preSurvey)
      for (let key of surveyKeys) {
        const surveyData = this.data.preSurvey[key]
        if (surveyData === undefined) {
          console.log('UnknownSurveyKey ', key)
          return
        }
        if (key === 'fcri_sf') {
          this.surveys.push({
            title: 'FCRI-SF',
            items: [
              { key: '点数', value: surveyData }
            ]
          })
        }
        if (key === 'phq9') {
          this.surveys.push({
            title: 'PHQ-9',
            items: [
              { key: '点数', value: surveyData }
            ]
          })
        }
        if (key === 'gad7') {
          this.surveys.push({
            title: 'GAD-7',
            items: [
              { key: '点数', value: surveyData }
            ]
          })
        }
        if (key === 'pas') {
          const items = [
            { key: 'つらさの寒暖計', value: surveyData.hardship }
          ]
          if (surveyData.others) {
            items.push({ key: 'そのほか困っていること', value: surveyData.others })
          }
          this.surveys.push({
            title: '苦痛スクリーニング',
            items: items
          })
        }
      }
    } else {
      this.surveys = []
    }
  }
}

interface DataTableItem {
  key: string;
  value: string;
  valueClass?: string;
  type?: string;
}
